import React, { useState, Suspense } from "react";
import { Route } from "react-router-dom";
import Loading from "../../components/common/Loading";
import "../../App.css";
import "./mainlayout.css";
import "../dashboardNew/styles/styles.css";
/*import '../AppRtl.css';*/
import AdminSideNav from "../../components/common/sideNav/adminSideNav.js";
import Header from "../../components/common/header/header";

import { PayloadContext } from "../../libs/context";
import { userFullName } from "../../libs/utils";

const AdminLayout = (props) => {
  const [openSideNav, setOpenSideNav] = useState(false);
  const handleOpen = (flag) => {
    setOpenSideNav(flag);
  };
  const handleCloseSideNav = () => {
    setOpenSideNav(false);
  };

  return (
    <PayloadContext.Consumer>
      {({ payload }) => (
        <div className="mainLayout">
          <Header handleSideNav={handleOpen} active={openSideNav} {...props} />
          <div className="mainContainer">
            {false && (
              <div
                className={
                  openSideNav
                    ? "responsiveSideNav block320 slideInSideNav"
                    : "responsiveSideNav block320"
                }
              >
                <div className="resNavHdr">
                  <div className="resNavLogoBlock">
                    {/* <img src="/images/logos/instavc-logo-small-48.png" alt="logo" className="resNavLogo" /> */}
                    <img
                      src="/images/logos/inclass.png"
                      alt="invc logo"
                      className="resNavLogo"
                    />
                  </div>
                  <div className="resNavCloseBlock">
                    {/* <IconButton aria-label="close" onClick={handleSlideOut}>
                  <CloseIcon />
                </IconButton> */}
                    {/* <Controls.CloseButton onClick={handleSlideOut} /> */}
                  </div>
                </div>
                <div className="resSdnNavUsrInfo">
                  <div className="resSdnNavUsrAvtr">
                    <span>{payload?.firstName?.[0].toUpperCase()}</span>
                    <span>{payload?.lastName?.[0].toUpperCase()}</span>
                  </div>
                  <span className="font16Txt mrgTop8 mrgBtm8">
                    {userFullName(payload)}
                  </span>
                  <span className="font14Txt">{payload?.email}</span>
                </div>
                <AdminSideNav {...props} />
              </div>
            )}
            <div className="newDBCntrn">
              <div className="scrollBlockFlex">
                <Suspense fallback={<Loading />}>
                  <Route exact path={props.path} component={props.component} />
                </Suspense>
              </div>
            </div>
            {/* <div className="wrapperLayout mrgnLeft320">
              <div className="fullStretchWrapper">
                <Suspense fallback={<Loading />}>
                  <Route exact path={props.path} component={props.component} />
                </Suspense>
              </div>
            </div> */}
          </div>
        </div>
      )}
    </PayloadContext.Consumer>
  );
};

export default AdminLayout;
